type GetProductLinkProps = {
  isBot: boolean;
  trackingLink?: string;
  productLink: string;
};

export const getProductLink = ({ isBot, productLink, trackingLink }: GetProductLinkProps) => {
  if (isBot && trackingLink) {
    // If the user is a bot and a tracking link (which is used only for criteo) is provided, return undefined
    return undefined;
  }

  // If trackingLink is provided, use it; otherwise, use productLink
  return trackingLink || productLink;
};
